export const memberData = [
  {
    subscriptionDuration: "FitnessApp",
    details: {
      intro: "Your First 30 Days Are FREE – Start Seeing Results Fast!",
      bullets: [
        "Access to over 200 live & on demand BFR workouts",
        "Access to BFR masterclasses and educational series",
        "Join a community focused on fitness, recovery & motivation",
      ],
      renewal:
        "After 30 days, your subscription will automatically renew at only $14.99 - $29.99/month.",
      contactEmail: "support@b3sciences.com",
    },
    sku: "B3SubTD",
    images: ["B3U1.png", "B3U2.png", "B3U3.png"],
    todayPrice: "0",
    videoId:"1045383546"
    
  },
  {
    subscriptionDuration: "App – 6 Months",
    details: {
      intro: "",
      bullets: ["Full Access for 6 Months", "Only $19.99 per month"],
      renewal: "Renews at 6 months.",
      contactEmail: "support@b3sciences.com",
    },
    sku: "B3Sub6m",
    images: ["B3U2.png", "B3U1.png", "B3U3.png"],
    todayPrice: "119.99",
    videoId:"1045383546"
  },
  {
    subscriptionDuration: "App – 12 Months",
    details: {
      intro: "",
      bullets: ["Full Access for 12 Months", "Only $14.99 per month"],
      renewal: "Renews at 12 months.",
      contactEmail: "support@b3sciences.com",
    },
    sku: "B3Sub12m",
    images: ["B3U3.png", "B3U2.png", "B3U1.png"],
    todayPrice: "179.99",
    videoId:"1045383546"
  },
  {
    subscriptionDuration: "MVP Program",
    details: {
      intro: "",
      bullets: ["Pilot Program for Ladies only","Private Coaching with Ashley – Seli Strength","Free first month"],
      renewal:
        "After 30 days, your subscription will renew at $299.99 per month.",
      contactEmail: "support@b3sciences.com",
    },
    sku: "B3UmvpTD",
    images: ["mvp1.png", "mvp2.png", "mvp3.png"],
    todayPrice: "0",
    videoId:""
  },
];
